import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { checkArray, checkNull, decimalValue } from "../../../../helpers";
import {
  changeSettingValue,
  downloadAllFinanceAcc,
  getFinanceAccounts,
  getFinanceChartOfAccSettings,
} from "../../../../Redux/actions";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const ChartOfAccounts = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { chart_of_accounts_details, sub_accounts_details } = useSelector(
    (state) => state.settingReducer
  );

  useEffect(() => {
    dispatch(getFinanceChartOfAccSettings());

    return () => {
      dispatch(changeSettingValue("chart_of_accounts_details", null));
      dispatch(changeSettingValue("sub_accounts_details", null));
    };
  }, []);

  const [searchVal, setSearchVal] = useState("");
  const [clearSearchCon, setClearSearchCon] = useState(false);

  const subAccountHandler = (
    group_id,
    type,
    parent_account_id,
    page = 1,
    pagesize = 10
  ) => {
    const subAccData = {
      group_id,
      type,
      parent_account_id,
      page,
      pagesize,
    };
    dispatch(getFinanceAccounts(subAccData));
  };

  const getTableClassName = (typeName = "") => {
    let res = "";
    if (typeName == "Liabilities") {
      res = "liability";
    } else if (typeName == "Income") {
      res = "income_tbl";
    } else if (typeName == "Assets") {
      res = "asset_tbl";
    }
    return res;
  };
  const getTableHead = (typeName = "") => {
    let res = null;
    if (typeName == "Income") {
      res = (
        <>
          <th class="just_right">Taxable?</th>
          <th class="just_right"></th>
          <th class="just_right"></th>
          <th class="just_right actions-td">Actions</th>
        </>
      );
    } else if (typeName == "Expense" || typeName == "Equity") {
      res = (
        <>
          <th class="just_right"></th>
          <th class="just_right"></th>
          <th class="just_right"></th>
          <th class="just_right actions-td">Actions</th>
        </>
      );
    } else if (typeName == "Assets") {
      res = (
        <>
          <th class="just_right">Accum. Apprec./Deprec.</th>
          <th class="just_right">YTD Accrued Apprec./Deprec.</th>
          <th class="flex-adj"> </th>
          <th class="just_right actions-td">Actions</th>
        </>
      );
    } else if (typeName == "Liabilities") {
      res = (
        <>
          <th class="just_right">30-Day Aged Balance</th>
          <th class="just_right">60-Day Aged Balance</th>
          <th class="just_right">90-Day+ Aged Balance</th>
          <th class="just_right actions-td">Actions </th>
        </>
      );
    }
    return res;
  };
  const getTableBody = (
    typeName = "",
    accum,
    ytd_accrued,
    days_30,
    days_60,
    days_90
  ) => {
    let res = (
      <>
        <td></td>
        <td></td>
        <td></td>
      </>
    );
    if (typeName == "Assets") {
      res = (
        <>
          <td class="text-right">{decimalValue(accum)}</td>
          <td class="text-right">{decimalValue(ytd_accrued)}</td>
          <td class="flex-adj"></td>
        </>
      );
    } else if (typeName == "Liabilities") {
      res = (
        <>
          <td class="text-right">{decimalValue(days_30)}</td>
          <td class="text-right">{decimalValue(days_60)}</td>
          <td class="text-right">{decimalValue(days_90)}</td>
        </>
      );
    }
    return res;
  };
  const getInnerTableBody = (
    typeName = "",
    account,
    accum1,
    ytd_accrued1,
    accum2,
    ytd_accrued2
  ) => {
    let res = (
      <>
        <td></td>
        <td></td>
        <td></td>
      </>
    );
    if (typeName == "Assets") {
      if (account?.finance_group_id == 7) {
        res = (
          <>
            <td class="text-right">{decimalValue(accum1)}</td>
            <td class="text-right">{decimalValue(ytd_accrued1)}</td>
            <td class="flex-adj"></td>
          </>
        );
      } else if (account?.finance_group_id == 8) {
        res = (
          <>
            <td class="text-right">{decimalValue(accum2)}</td>
            <td class="text-right">{decimalValue(ytd_accrued2)}</td>
            <td class="flex-adj"></td>
          </>
        );
      }
    } else if (typeName == "Liabilities") {
      res = (
        <>
          <td class="text-right">{decimalValue(account?.thirty_days)}</td>
          <td class="text-right">{decimalValue(account?.sixty_days)}</td>
          <td class="text-right">{decimalValue(account?.ninety_days)}</td>
        </>
      );
    }
    return res;
  };

  const getSubAccBody = (subAcc) => {
    let res = null;
    let actionIcon = null;
    if (subAcc?.have_custom_account == 1) {
      actionIcon = (
        <a
          role="button"
          className="circle_icon"
          onClick={() => addAccountHandler(subAcc?.id)}
        >
          <i class="plus-icon"> </i>
        </a>
      );
    } else if (subAcc?.editable == 1) {
      actionIcon = (
        <a
          role="button"
          className="circle_icon"
          onClick={() => showSubAccountHandler(subAcc?.id)}
        >
          <i class="iconSprites edit-icon"></i>
        </a>
      );
    } else if (subAcc?.subaccount_count > 0) {
      actionIcon = (
        <a
          role="button"
          className="circle_icon"
          onClick={() => addAccountHandler(subAcc?.id)}
        >
          <i class="iconSprites eye-icon"></i>
        </a>
      );
    } else {
      actionIcon = (
        <a
          role="button"
          className="circle_icon"
          onClick={() => showSubAccountHandler(subAcc?.id)}
        >
          <i class="iconSprites eye-icon"></i>
        </a>
      );
    }
    if (subAcc?.finance_type?.name == "Income") {
      res = (
        <>
          <td class="just_right">{subAcc?.taxable == 1 ? "Yes" : "No"}</td>
          <td class="just_right"></td>
          <td class="just_right"></td>
          <td class="actions-td">{actionIcon}</td>
        </>
      );
    } else if (
      subAcc?.finance_type?.name == "Expense" ||
      subAcc?.finance_type?.name == "Equity"
    ) {
      res = (
        <>
          <td class="just_right"></td>
          <td class="just_right"></td>
          <td class="just_right"></td>
          <td class="actions-td">{actionIcon}</td>
        </>
      );
    } else if (subAcc?.finance_type?.name == "Assets") {
      res = (
        <>
          <td class="just_right">{subAcc?.accum_appr_depr}</td>
          <td class="just_right">{subAcc?.ytd_appr_depr}</td>
          <td class="just_right flex-adj"></td>
          <td class="actions-td">{actionIcon}</td>
        </>
      );
    } else if (subAcc?.finance_type?.name == "Liabilities") {
      res = (
        <>
          <td class="just_right">{decimalValue(subAcc?.thirty_days)}</td>
          <td class="just_right">{decimalValue(subAcc?.sixty_days)}</td>
          <td class="just_right">{decimalValue(subAcc?.ninety_days)}</td>
          <td class="actions-td">{actionIcon}</td>
        </>
      );
    }
    return res;
  };

  const getSubAccItems = (account) => {
    let res = null;
    if (checkNull(sub_accounts_details?.[account?.id], false)) {
      let subAccData = sub_accounts_details?.[account?.id];
      res = checkArray(subAccData?.data)
        ? subAccData?.data.map((subAcc) => {
            return (
              <>
                <tr className="tr_bg">
                  <td>
                    {subAcc?.subaccount_count > 0 ? (
                      <>
                        <button
                          class="show_accounts dropdown-green collapsed"
                          data-bs-toggle="collapse"
                          type="button"
                          data-bs-target={`#tableName_${subAcc?.id}`}
                          aria-expanded="false"
                          onClick={() => {
                            if (
                              !checkNull(
                                sub_accounts_details?.[subAcc?.id],
                                false
                              )
                            ) {
                              subAccountHandler(
                                subAcc?.finance_group_id,
                                "subaccount",
                                subAcc?.id
                              );
                            }
                          }}
                        ></button>
                        <span class="td_bg"> </span>
                      </>
                    ) : null}
                    <p>
                      {subAcc?.account_id} - {subAcc?.name}
                    </p>
                  </td>
                  <td class="parent_acc">
                    {checkNull(subAcc?.parent?.name, false)
                      ? subAcc?.parent?.name
                      : subAcc?.finance_group?.name}
                  </td>
                  <td class="text-right current_acc">
                    {decimalValue(subAcc?.current_balance)}
                  </td>
                  {getSubAccBody(subAcc)}
                </tr>
                <tr
                  id={`tableName_${subAcc?.id}`}
                  className={`p-0 collapse ${
                    subAcc?.finance_group_id == 0 ? "in" : ""
                  }`}
                >
                  <td colspan="6" className="p-0">
                    <table className="table">
                      <tbody className={`child_table_${subAcc?.id}`}>
                        {getSubAccItems(subAcc)}
                      </tbody>
                    </table>
                  </td>
                </tr>
                {sub_accounts_details?.[subAcc?.id] &&
                  sub_accounts_details?.[subAcc?.id].totalPages >
                    sub_accounts_details?.[subAcc?.id].page && (
                    <tr>
                      <td colSpan="7" align="center">
                        <a
                          role="button"
                          className="show_accounts"
                          onClick={() =>
                            subAccountHandler(
                              subAcc?.finance_group_id,
                              "subaccount",
                              subAcc?.id,
                              sub_accounts_details?.[subAcc?.id].page + 1
                            )
                          }
                        >
                          Load More
                        </a>
                      </td>
                    </tr>
                  )}
              </>
            );
          })
        : null;
    }
    return res;
  };

  const searchChartOfAccHandler = (val) => {
    dispatch(getFinanceChartOfAccSettings(`?keyword=${val}`));
    if (val !== "") {
      setClearSearchCon(true);
    } else {
      setClearSearchCon(false);
    }
  };

  const addAccountHandler = (accountId) => {
    history.push(`/settings/finance/chart-of-accounts/accounts/${accountId}`);
  };

  const showSubAccountHandler = (accountId) => {
    history.push(
      `/settings/finance/chart-of-accounts/subAccounts/${accountId}`
    );
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="top-header-sec mb-3">
              <div className="col-12 mt-3">
                <h4 className="event-alert br-btm-0">
                  Account List
                  <div className="clear"></div>
                </h4>
                <div className="row justify-content-between align-items-center">
                  <div className="col-md-6 col-10">
                    <div className="search-box mt-0">
                      <input
                        type="text"
                        placeholder="Search"
                        name="keyword1"
                        onChange={(e) => setSearchVal(e?.target?.value)}
                        value={searchVal}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            searchChartOfAccHandler(searchVal);
                          }
                        }}
                      />
                      <input
                        type="button"
                        onClick={() => searchChartOfAccHandler(searchVal)}
                      />
                    </div>
                  </div>

                  <div className="col-md-4 col-2 align-right">
                    <div className="field text-right">
                      <button
                        id="download"
                        className="btn green-btn-revert download-icon mr0"
                        onClick={() => dispatch(downloadAllFinanceAcc())}
                      >
                        <i className="i-icon"> </i> Download
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {clearSearchCon && (
              <div class="shadowclass padding_b">
                <h5>
                  Showing Search results for - {searchVal}
                  <span class="mrglft20">
                    <a
                      className="link"
                      role="button"
                      onClick={() => {
                        setSearchVal("");
                        searchChartOfAccHandler("");
                      }}
                    >
                      Clear Search
                    </a>
                  </span>
                </h5>
              </div>
            )}
            {checkArray(chart_of_accounts_details?.types) &&
              chart_of_accounts_details?.types.map((type) => {
                const totalCurrentBalance = checkArray(type?.finance_account)
                  ? type?.finance_account.reduce((sum, current) => {
                      return sum + current.current_balance;
                    }, 0)
                  : 0;
                let accum =
                  checkArray(type?.finance_account) && type?.name == "Assets"
                    ? type?.finance_account.reduce((sum, current) => {
                        return sum + current?.accum_appr_depr ?? 0;
                      }, 0)
                    : 0;
                let accum1 =
                  checkArray(type?.finance_account) && type?.name == "Assets"
                    ? type?.finance_account.reduce((sum, current) => {
                        return sum + (current?.finance_group_id == 7)
                          ? current?.accum_appr_depr ?? 0
                          : 0;
                      }, 0)
                    : 0;
                let accum2 =
                  checkArray(type?.finance_account) && type?.name == "Assets"
                    ? type?.finance_account.reduce((sum, current) => {
                        return sum + (current?.finance_group_id == 8)
                          ? current?.accum_appr_depr ?? 0
                          : 0;
                      }, 0)
                    : 0;
                let ytd_accrued =
                  checkArray(type?.finance_account) && type?.name == "Assets"
                    ? type?.finance_account.reduce((sum, current) => {
                        return sum + current?.ytd_appr_depr ?? 0;
                      }, 0)
                    : 0;
                let ytd_accrued1 =
                  checkArray(type?.finance_account) && type?.name == "Assets"
                    ? type?.finance_account.reduce((sum, current) => {
                        return sum + (current?.finance_group_id == 7)
                          ? current?.ytd_appr_depr ?? 0
                          : 0;
                      }, 0)
                    : 0;
                let ytd_accrued2 =
                  checkArray(type?.finance_account) && type?.name == "Assets"
                    ? type?.finance_account.reduce((sum, current) => {
                        return sum + (current?.finance_group_id == 8)
                          ? current?.ytd_appr_depr ?? 0
                          : 0;
                      }, 0)
                    : 0;
                let days_30 =
                  checkArray(type?.finance_account) &&
                  type?.name == "Liabilities"
                    ? type?.finance_account.reduce((sum, current) => {
                        return sum + current?.["thirty_days"] ?? 0;
                      }, 0)
                    : 0;
                let days_60 =
                  checkArray(type?.finance_account) &&
                  type?.name == "Liabilities"
                    ? type?.finance_account.reduce((sum, current) => {
                        return sum + current?.["sixty_days"] ?? 0;
                      }, 0)
                    : 0;
                let days_90 =
                  checkArray(type?.finance_account) &&
                  type?.name == "Liabilities"
                    ? type?.finance_account.reduce((sum, current) => {
                        return sum + current?.["ninety_days"] ?? 0;
                      }, 0)
                    : 0;
                return (
                  <div class="inner-space income-table">
                    <div class="accordion-wrap">
                      <div
                        className="accordion inv-accordion Account_list_table"
                        id="accordionPanelsStayOpenExample"
                      >
                        <div className="accordion-item">
                          <h2
                            className="accordion-header"
                            id={`panelsStayOpen-headingNine${type?.id}`}
                          >
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#panelsStayOpen-collapseNine${type?.id}`}
                              aria-expanded="true"
                              aria-controls={`panelsStayOpen-collapseNine${type?.id}`}
                            >
                              <div className="col d-flex align-items-center justify-content-between">
                                <h4 className="event-alert p-0 mb-0">
                                  {type?.name}
                                </h4>
                                <h5 className="bal-h5">
                                  Balance: {decimalValue(totalCurrentBalance)}
                                </h5>
                              </div>
                            </button>
                          </h2>
                          <div
                            id={`panelsStayOpen-collapseNine${type?.id}`}
                            className="screen-scroll accordion-collapse collapse show"
                            aria-labelledby={`panelsStayOpen-headingNine${type?.id}`}
                          >
                            <div class="shadowclass padding_b mt-0">
                              <div className="table-responsive">
                                <table
                                  width="100%"
                                  cellspacing="0"
                                  cellpadding="0"
                                  className={`mb-0 checklist-table remove-space inventory_table filterTable ${getTableClassName(
                                    type
                                  )}`}
                                >
                                  <thead>
                                    <tr>
                                      <th class="second-th" width="24%">
                                        Account ID -{type?.name} Account
                                      </th>
                                      <th class="parent_acc">
                                        <a> Parent Account</a>
                                      </th>
                                      <th class="just_right current_acc">
                                        <a> Current Balance</a>
                                      </th>
                                      {getTableHead(type?.name)}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="main-tr">
                                      <td>
                                        <button
                                          class="dropdown-green collapsed"
                                          type="button"
                                          data-bs-toggle="collapse"
                                          data-bs-target={`#tableRow_${type?.id}`}
                                          aria-expanded="false"
                                          aria-controls={`tableRow_${type?.id}`}
                                        >
                                          {" "}
                                        </button>{" "}
                                        <span class="td_bg"></span>
                                        <p>
                                          {" "}
                                          {type?.account_id} - {type?.name}
                                        </p>
                                      </td>
                                      <td class="parent_acc"></td>
                                      <td
                                        class={`text-right balance_accounts${type?.id} current_acc`}
                                      >
                                        {decimalValue(totalCurrentBalance)}
                                      </td>
                                      {getTableBody(
                                        type?.name,
                                        accum,
                                        ytd_accrued,
                                        days_30,
                                        days_60,
                                        days_90
                                      )}
                                      <td class="actions-td"></td>
                                    </tr>
                                    <tr
                                      id={`tableRow_${type?.id}`}
                                      class="collapse"
                                    >
                                      <td colspan="6" class="p-0">
                                        <table class="table accordion_table">
                                          <tbody>
                                            {checkArray(
                                              type?.finance_account
                                            ) &&
                                              type?.finance_account.map(
                                                (account) => {
                                                  return (
                                                    <>
                                                      <tr>
                                                        <td class="assets-ac">
                                                          <button
                                                            class="show_accounts dropdown-green collapsed"
                                                            data-bs-toggle="collapse"
                                                            type="button"
                                                            data-bs-target={`#tableName_${account?.id}`}
                                                            aria-expanded="false"
                                                            acc_type="subaccount"
                                                            fin_type={`${type?.id}`}
                                                            parent_account_id={`${account?.id}`}
                                                            fin_group={`${account?.finance_group_id}`}
                                                            onClick={() => {
                                                              if (
                                                                !checkNull(
                                                                  sub_accounts_details?.[
                                                                    account?.id
                                                                  ],
                                                                  false
                                                                )
                                                              ) {
                                                                subAccountHandler(
                                                                  account?.finance_group_id,
                                                                  "subaccount",
                                                                  account?.id
                                                                );
                                                              }
                                                            }}
                                                          ></button>
                                                          <span class="td_bg">
                                                            {" "}
                                                          </span>
                                                          <p>
                                                            {" "}
                                                            {account?.id} -
                                                            {account?.name}
                                                          </p>
                                                        </td>
                                                        <td class="parent_acc">
                                                          {type?.name}
                                                        </td>
                                                        <td class="text-right current_acc">
                                                          {decimalValue(
                                                            account?.current_balance
                                                          )}
                                                        </td>
                                                        {getInnerTableBody(
                                                          type,
                                                          account,
                                                          accum1,
                                                          ytd_accrued1,
                                                          accum2,
                                                          ytd_accrued2
                                                        )}

                                                        <td class="actions-td">
                                                          {account?.have_custom_account ==
                                                          1 ? (
                                                            <a
                                                              role="button"
                                                              class="circle_icon"
                                                              onClick={() =>
                                                                addAccountHandler(
                                                                  account?.id
                                                                )
                                                              }
                                                            >
                                                              <i class="plus-icon">
                                                                {" "}
                                                              </i>
                                                            </a>
                                                          ) : null}
                                                        </td>
                                                      </tr>
                                                      <tr
                                                        id={`tableName_${account?.id}`}
                                                        class={`p-0  collapse ${
                                                          account?.finance_group_id ==
                                                          0
                                                            ? "in"
                                                            : ""
                                                        }`}
                                                      >
                                                        <td
                                                          colspan="6"
                                                          class="p-0"
                                                        >
                                                          <table class="table">
                                                            <tbody
                                                              class={`child_table_${account?.id}`}
                                                            >
                                                              {getSubAccItems(
                                                                account
                                                              )}
                                                            </tbody>
                                                          </table>
                                                        </td>
                                                      </tr>
                                                    </>
                                                  );
                                                }
                                              )}
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default ChartOfAccounts;
